/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInventoryTransactionRequest } from '../../models/create-inventory-transaction-request';
import { InventoryTransactionDto } from '../../models/inventory-transaction-dto';

export interface CreateInventoryTransaction$Params {
      body: CreateInventoryTransactionRequest
}

export function createInventoryTransaction(http: HttpClient, rootUrl: string, params: CreateInventoryTransaction$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryTransactionDto>> {
  const rb = new RequestBuilder(rootUrl, createInventoryTransaction.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryTransactionDto>;
    })
  );
}

createInventoryTransaction.PATH = '/v0/inventoryTransactions';
